export type WakeAppSuccessStatus = "already_running" | "woke";
export type WakeAppDeferredStatus = "capacity_rejected" | "queue_timeout";

export type WakeAppSuccessResult = {
  ok: true;
  status: WakeAppSuccessStatus;
  port: number;
};

export type WakeAppDeferredResult = {
  ok: false;
  status: WakeAppDeferredStatus;
  retryAfterSec: number;
};

export type WakeAppBootFailedResult = {
  ok: false;
  status: "boot_failed";
  error: string;
};

export type WakeAppResult = WakeAppSuccessResult | WakeAppDeferredResult | WakeAppBootFailedResult;

export const DEFAULT_WAKE_RETRY_AFTER_SEC = 30;

export function buildWakeAppSuccessResult(status: WakeAppSuccessStatus, port: number): WakeAppSuccessResult {
  return { ok: true, status, port };
}

export function buildWakeAppBootFailedResult(error: unknown): WakeAppBootFailedResult {
  const message = error instanceof Error ? error.message : String(error);
  return { ok: false, status: "boot_failed", error: message };
}

export function isWakeAppDeferredResult(result: WakeAppResult): result is WakeAppDeferredResult {
  return !result.ok && (result.status === "capacity_rejected" || result.status === "queue_timeout");
}
